import './styles.scss';

interface IProps {
    image: string;
    showMobile?: boolean;
}

const SideImage = ({ image, showMobile = true }: IProps) => {
    const classMobile = showMobile ? 'col-12' : 'd-none';
    return (
        <div id="SideImage" className={`${classMobile} d-md-block col-md-6 carousel-container`}>
            <div className="auth-full-bg pt-lg-5 p-4">
                <div className="w-100">
                    <div className="bg-overlay"></div>
                    <div className="d-flex h-100 flex-column">
                        <div className="image-text-container text-center">
                            <img src={image} alt="Plataforma de Influencer"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SideImage;